userMgmt_action_map = {
    'setSuper': 0,
    'setAdmin': 1,
    'setUser': 9,
    'unApprove': -1,
    'setGuest': 10,
    'approve': 9,
    'forbid': -9,
    'delete': -99,
    'unDelete': 9,
    'unForbid': 9
};